import { On3IconAnchorArrow, On3IconCircleCheck } from '@on3/icons';
import { useSite } from '@on3/ui-lib/index';
import clsx from 'clsx';
import { useState } from 'react';

import styles, { gray, positiveDay } from './PerkChecklistItem.module.scss';

interface IPerkChecklistProps {
  label: string;
  description?: string | null;
}
export const PerkChecklistItem = (props: IPerkChecklistProps) => {
  const { label, description } = props || {};
  const [open, setOpen] = useState(false);
  const { currentSite } = useSite();
  const teamColor = currentSite?.primaryColor || positiveDay;

  return (
    <li className={styles.item}>
      {description ? (
        <button
          className={clsx({ [styles.open]: open })}
          onClick={() => setOpen(!open)}
        >
          <On3IconAnchorArrow fill={gray} />

          <p className={styles.label} data-type="label">
            {label}
          </p>
          <On3IconCircleCheck fill={teamColor} />
        </button>
      ) : (
        <div className={styles.block}>
          <On3IconAnchorArrow fill={gray} />
          <p className={styles.label} data-type="label">
            {label}
          </p>
          <On3IconCircleCheck fill={teamColor} />
        </div>
      )}
      {open && (
        <div className={styles.description}>
          <p>{description}</p>
        </div>
      )}
    </li>
  );
};
